export default __webpack_public_path__ + "static/media/Ausbildung.ac31486b.svg";